import Icon from '../components/Icon.vue'

Icon.register({
  tree: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M378.3 378.5c6 6.8 7.4 16.1 3.6 24.3-3.8 8-12 13.3-21 13.3h-136.9v24.5l30.3 48.4c5.3 10.6-2.4 23.2-14.3 23.2h-96c-11.9 0-19.6-12.5-14.3-23.2l30.3-48.4v-24.5h-136.9c-9 0-17.3-5.2-21-13.3-3.8-8.2-2.4-17.5 3.6-24.3l79.9-90.5h-30.6c-9 0-17-5-20.8-13-3.8-8-2.5-17.3 3.3-24l78.1-90.9h-28.9c-9.1 0-17.3-5.3-20.9-13.6-3.5-8.1-1.9-17.6 4.2-24.1l110.3-117.5c6-6.5 17.3-6.5 23.3 0l110.3 117.5c6.1 6.5 7.8 16 4.2 24.1-3.6 8.3-11.8 13.6-20.9 13.6h-28.9l78.1 90.9c5.8 6.8 7.1 16 3.3 24.1-3.8 8.1-11.8 13.1-20.8 13.1h-30.6z'
      }
    ]
  }
})
